import React, { useState } from "react";
import {
    Alert,
    Form,
    Input,
    Select,
    Row,
    Col,
    Card,
    Radio,
    Button,
    Table,
    Checkbox,
    Typography,
} from "antd";
import BackHome from "../components/BackHome";
import { motion } from 'framer-motion';
import { useTranslation } from "react-i18next";

const { Option } = Select;
const { TextArea } = Input;

const CheckoutPage = () => {
    const [form] = Form.useForm();
    const [paymentMethod, setPaymentMethod] = useState("bank");
    const [showLogin, setShowLogin] = useState(false);

    const orderItems = [
        {
            key: "1",
            product: "Long Sleeve Shirt x 1",
            total: 90.0,
        },
    ];

    const columns = [
        {
            title: "Product",
            dataIndex: "product",
        },
        {
            title: "Total",
            dataIndex: "total",
            render: (value) => (
                <span style={{ color: "green" }}>${value.toFixed(2)}</span>
            ),
        },
    ];

    const infoBoxStyle = {
        backgroundColor: "#dfdcde",
        color: "#333",
        // margin: "10px 0 20px 24px",
        padding: "16px",
        borderRadius: "4px",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
        position: "relative",
        fontSize: "14px",
        lineHeight: "1.6",
        maxWidth: "100%",
    };

    const triangleStyle = {
        content: "''",
        position: "absolute",
        top: "-8px",
        left: "20px",
        width: "0",
        height: "0",
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        borderBottom: "8px solid #f8f9fa",
    };

    const handleFinish = (values) => {
        console.log("✅ Order Placed:", values);
        // Proceed with order processing here
    };

    const handleFinishFailed = (errorInfo) => {
        console.log("❌ Validation Failed:", errorInfo);
    };
    const { Title, Link } = Typography;
    const { t } = useTranslation();

    return (
        <>
            <BackHome title={t("Checkout")} t={t}/>
            <div style={{ padding: 24, maxWidth: 1000, margin: "0 auto" }}>
                <Alert
                    message={
                        <span>
                            Returning customer?{" "}
                            <Link onClick={() => setShowLogin(prev => !prev)}>Click here to login</Link>
                        </span>
                    }
                    type="info"
                    showIcon
                    style={{ marginBottom: 24 }}
                />
                {showLogin && (
                    <>
                        <motion.div
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.5 }}
                            style={{ overflow: 'hidden', marginTop: 16 }}
                        >
                            <Card style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                                <Title level={4}>Login</Title>
                                <p>If you have shopped with us before, please enter your details below.</p>
                                <Form layout="vertical">
                                    <Form.Item label="Username or email" name="email" rules={[{ required: true }]}>
                                        <Input size="large" />
                                    </Form.Item>
                                    <Form.Item label="Password" name="password" rules={[{ required: true }]}>
                                        <Input.Password size="large" />
                                    </Form.Item>
                                    <Form.Item name="remember" valuePropName="checked">
                                        <Checkbox>Remember me</Checkbox>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type="primary" size="large" htmlType="submit" style={{backgroundColor:"rgb(17, 152, 17)"}}>Login</Button>
                                    </Form.Item>
                                    <Link href="#">Lost your password?</Link>
                                </Form>
                            </Card>
                        </motion.div>
                        <div className="esi-white-space" />
                    </>
                )}

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleFinish}
                    onFinishFailed={handleFinishFailed}
                >
                    <Card title="Billing Details" bordered style={{ marginBottom: 24 }}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="First name"
                                    name="firstName"
                                    rules={[{ required: true, message: "First name is required" }]}
                                >
                                    <Input size="large" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Last name"
                                    name="lastName"
                                    rules={[{ required: true, message: "Last name is required" }]}
                                >
                                    <Input size="large" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item label="Company name (optional)" name="company">
                            <Input size="large" />
                        </Form.Item>

                        <Form.Item
                            label="Country"
                            name="country"
                            rules={[{ required: true, message: "Country is required" }]}
                        >
                            <Select placeholder="Select country" size="large">
                                <Option value="cambodia">Cambodia</Option>
                                <Option value="usa">USA</Option>
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label="Street address"
                            name="address1"
                            rules={[{ required: true, message: "Street address is required" }]}
                        >
                            <Input placeholder="House number and street name" size="large" />
                        </Form.Item>

                        <Form.Item name="address2">
                            <Input placeholder="Apartment, suite, unit etc. (optional)" size="large" />
                        </Form.Item>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Town / City"
                                    name="city"
                                    rules={[{ required: true, message: "City is required" }]}
                                >
                                    <Input size="large" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="State / Country"
                                    name="state"
                                    rules={[{ required: true, message: "State is required" }]}
                                >
                                    <Input size="large" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item
                            label="Postcode / ZIP"
                            name="zip"
                            rules={[
                                { required: true, message: "ZIP code is required" },
                                {
                                    pattern: /^[0-9]{5}$/,
                                    message: "ZIP code must be exactly 5 digits (0–9 only)",
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                maxLength={5}
                                inputMode="numeric"
                                onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault(); // block letters, symbols, and minus sign
                                    }
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Phone"
                            name="phone"
                            rules={[
                                { required: true, message: "Phone number is required" },
                                {
                                    pattern: /^[0-9]{1,15}$/,
                                    message: "Phone number must be 1 to 15 digits only",
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                maxLength={15}
                                inputMode="numeric"
                                onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault(); // block letters, symbols, and minus
                                    }
                                }}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Email address"
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Email is required",
                                },
                                {
                                    type: "email",
                                    message: "Please enter a valid email",
                                },
                                {
                                    pattern: /^[\w.-]+@[\w.-]+\.(com|org|net|gov|edu|info)$/i,
                                    message: "Only .com, .org, .net, .gov, .edu, or .info domains are allowed",
                                },
                            ]}
                        >
                            <Input size="large" />
                        </Form.Item>
                    </Card>

                    <Card title="Additional Information" bordered style={{ marginBottom: 24 }}>
                        <Form.Item label="Order notes (optional)" name="notes">
                            <TextArea rows={4} placeholder="Notes about your order, e.g. special notes for delivery." />
                        </Form.Item>
                    </Card>

                    <Card title="Your Order" bordered style={{ marginBottom: 24 }}>
                        <Table
                            dataSource={orderItems}
                            columns={columns}
                            pagination={false}
                            summary={() => (
                                <>
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell><strong>Subtotal</strong></Table.Summary.Cell>
                                        <Table.Summary.Cell>
                                            <span style={{ color: "green" }}>${90.0.toFixed(2)}</span>
                                        </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                    <Table.Summary.Row>
                                        <Table.Summary.Cell><strong>Total</strong></Table.Summary.Cell>
                                        <Table.Summary.Cell>
                                            <span style={{ color: "green" }}>${90.0.toFixed(2)}</span>
                                        </Table.Summary.Cell>
                                    </Table.Summary.Row>
                                </>
                            )}
                        />
                    </Card>

                    <Card bordered style={{ marginBottom: 24, paddingTop: "20px", paddingBottom: "20px" }}>
                        <Radio.Group
                            onChange={(e) => setPaymentMethod(e.target.value)}
                            value={paymentMethod}
                        >
                            <Radio value="bank" size="large">Direct bank transfer</Radio>
                            <Radio value="check" size="large">Check payments</Radio>
                            <Radio value="cod" size="large">Cash on delivery</Radio>
                        </Radio.Group>

                        {paymentMethod === "bank" && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.5 }}
                                style={{ overflow: 'hidden', marginTop: 16 }}
                            >
                                <div style={infoBoxStyle}>
                                    <div style={triangleStyle} />
                                    Make your payment directly into our bank account. Use your Order ID as the payment reference. Your order will not be shipped until the funds have cleared in our account.
                                </div>
                            </motion.div>
                        )}
                        {paymentMethod === "check" && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.5 }}
                                style={{ overflow: 'hidden', marginTop: 16 }}
                            >
                                <div style={infoBoxStyle}>
                                    <div style={triangleStyle} />
                                    Please send a check to our company address. Your order will be processed once the check has cleared.
                                </div>
                            </motion.div>
                        )}
                        {paymentMethod === "cod" && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.5 }}
                                style={{ overflow: 'hidden', marginTop: 16 }}
                            >
                                <div style={infoBoxStyle}>
                                    <div style={triangleStyle} />
                                    Pay with cash upon delivery. Please ensure someone is available to receive the order.
                                </div>
                            </motion.div>
                        )}
                    </Card>

                    <Button type="primary" block size="large" htmlType="submit" style={{backgroundColor:"rgb(17, 152, 17)"}}>
                        Place Order
                    </Button>
                </Form>
            </div>
            <div className="esi-white-space" />
        </>
    );
};

export default CheckoutPage;
